import { takeLatest, put, all, call } from 'redux-saga/effects';

import kycSourcedReportTypes from './kyc-sourced-report.types';

import {
	// FETCH KYC SOURCED REPORT DETAILS
	getKYCSourcedReportSuccess,
	getKYCSourcedReportFailure,
	getKYCSourcedReportResponseResetChanged,
} from './kyc-sourced-report.action';

import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
import { getKYCSourcedReportDetails } from './kyc-sourced-report.services';

/** *********************  START GET KYC SOURCED DETAILS  ******************** */
export function* getKYCReport({ payload }: any) {
	try {
		const key = 'KYCSourcedReportDetailsKey';
		const { companyID, databaseName, centerID, fromDate, toDate, branchID, officerID } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			CenterID: centerID,
			FromDate: fromDate,
			ToDate: toDate,
			BranchID: branchID,
			OfficerID: officerID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getKYCSourcedReportDetails, encodeData);
		if (responseData.data.statusCode === '101') {
			yield put(getKYCSourcedReportFailure(responseData.data));
		} else {
			yield put(getKYCSourcedReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getKYCSourcedReportFailure(error));
	}
}

export function* resetGetKYCSourcedReportResponse() {
	yield put(getKYCSourcedReportResponseResetChanged());
}

export function* onGetKYCSourcedReportDetails() {
	yield takeLatest(kycSourcedReportTypes.GET_KYC_SOURCED_REPORT_START, getKYCReport);
}

export function* onGetKYCSourcedReportResponseReset() {
	yield takeLatest(
		kycSourcedReportTypes.GET_KYC_SOURCED_REPORT_RESPONSE_RESET_START,
		resetGetKYCSourcedReportResponse,
	);
}
/** *********************  END GET KYC SOURCED DETAILS ******************** */

export function* kycSourcedReportSaga() {
	// FETCH KYC SOURCED REPORT DETAILS
	yield all([call(onGetKYCSourcedReportDetails), call(onGetKYCSourcedReportResponseReset)]);
}
